<template>
   <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="姓名:" prop="name">
          <el-input clearable v-model="table.params.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="电话:" prop="account">
          <el-input clearable v-model="table.params.account" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所在区域:" prop="area" v-if="cur_area == 0">
          <el-cascader
            style="width:100%;"
            v-model="table.params.area"
            :options="areaArr"
            :props="{ checkStrictly: true, emitPath: false }">
          </el-cascader>
        </el-form-item> -->
        <el-form-item label="排序:" prop="sort">
          <el-radio-group v-model="table.params.sort" @change="getTable">
            <el-radio-button :label="1">服务次数<i class="el-icon-arrow-down"></i></el-radio-button>
            <el-radio-button :label="2">评价次数<i class="el-icon-arrow-down"></i></el-radio-button>
            <el-radio-button :label="3">综合得分<i class="el-icon-arrow-down"></i></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button class="theneBtn" type="primary" icon="el-icon-search" @click="onSearch">查询 </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <VTable
      has-pagionation
      title=''
      addText='添加'
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page='table.params.page'
      :pageSize='table.params.count'
      :total='table.total'
      :hasPagionation="true"
      :default-expand-all="true"
      :showOverflowTooltip="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:province_str="{row}">
        <span>{{row.province_str}}{{row.city_str}}{{row.area_str}}{{row.street_str}}</span>
      </template>
      <template v-slot:type="{row}">
        <span>{{toStr({0:'未填',1:'学生',2:'自由职业',3:'宝妈',4:'全职'},row.type)}}</span>
      </template>
      <template v-slot:kinds="{row}">
        <span>{{row.kinds && row.kinds.length?row.kinds.join('、'):''}}</span>
      </template>
      <template v-slot:source="{row}">
        <span>{{row.source ? toStr({1:'微信', 2:'IOS', 3:'安卓', 4:'支付宝',5:'IOT',6:'设备端'}, row.source) : '' }}</span>
      </template>
    </VTable>

    
  </div>
</template>

<script>
import VTable from '@/components/VTable';
import { mixinTable } from '@/mixins/table.js'
import { getStorage } from '@/storage/index.js'
export default {
  name: 'UserList',
  components: {
    VTable,
  },
  mixins: [mixinTable],
  data() {
    return {
      field: [
        { name: "nickname", label: "姓名",  width: "160", hidden: false },
        { name: "account", label: "联系电话", hidden: false },
        { name: "province_str", label: "所在地区", hidden: false },
        { name: "type", label: "身份", hidden: false },
        { name: "work_age", label: "工龄/年", hidden: false },
        { name: "kinds", label: "擅长工种", showTooltip: true,  hidden: false },
        { name: "service_num", label: "服务次数", hidden: false },
        { name: "score_num", label: "评价次数", hidden: false },
        { name: "user_score", label: "综合得分", hidden: false },
        { name: "agency_name", label: "邀请人", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          sort: '', // 排序 1:服务次数 2:评价次数 3:平均分
          area: '',
          name: '',
          account: '',
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
      },
      areaArr: [],
      cur_city: getStorage("city"),
      cur_area: getStorage("area"),
    }
  },
  created() {
    this.getTable();
    // this.getArea();
  },
  methods: {
    getTable() {
      this.$http.get('/agency/rank/list', { params:this.table.params }).then(res => {
        if(res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
        }
      })
    },
    // 根据市id查询区县
    // getArea() {
    //   this.$http.post('/common/district/all',{pid: this.cur_city}).then(res => {
    //     if(res.code == 1) {
    //       this.areaArr = res.data.list;
    //     }
    //   })
    // },
  }
}
</script>